<template>
  <div class="contaier">
    <!-- ------------------------ **start ------------------------ -->
    <div class="top-nav h-[80px]">
      <div class="top-logo max-md:w-[150px] max-sm:w-[120px]">
        <img
          class="img"
          src="https://img.kamlung.net/kia/pv5/KIAlogo_edited.avif"
          alt=""
        />
      </div>
      <!-- <div class="dropdown-box">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ speak }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="中文">中文</el-dropdown-item>
            <el-dropdown-item command="英文">英文</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
    </div>
    <!-- <test-page></test-page> -->
    <!-- ------------------------ **start ------------------------ -->
    <div class="top-banner">
      <div class="title-box top-[20px] max-md:top-[10px]">
        <div class="note text-[10px]">*實際車型車色及規格配備以實車為主</div>
        <div
          class="title1 lg:text-[60px] md:text-[40px] sm:text-[30px] text-[28px] lg:leading-[100px] md:leading-[80px] leading-[60px]"
        >
          永續移動 創新紀元
        </div>
        <div class="title2 lg:text-[35px] md:text-[28px] sm:text-[22px] text-[16px]">
          Kia 首款商客兩用純電車型 PV5
        </div>
        <!-- md:text-[22px]  -->
        <div
          @click="downloadPDF"
          class="download-btn sm:text-[20px] text-[16px] bg-black text-white lg:w-[180px] md:w-[180px] sm:w-[180px] w-[140px] lg:leading-[50px] md:leading-[50px] sm:leading-[40px] leading-[34px] rounded-full text-center mt-[15px]"
        >
          下載產品介紹書
        </div>
        <div></div>
      </div>

      <div class="contact-box bottom-[10%] max-md:bottom-[5%]">
        <div class="title2 lg:text-[35px] md:text-[28px] sm:text-[22px] text-[16px]">
          早著先機 把握機遇
        </div>
        <div class="title2 lg:text-[35px] md:text-[28px] sm:text-[22px] text-[16px]">
          <a href="tel:27609933">了解更多：2760 9933 </a>
        </div>
      </div>
      <img
        alt=""
        class="img lg:aspect-5/3 md:aspect-3/3 aspect-4/5"
        src="https://img.kamlung.net/kia/pv5/banner2.jpg"
      />
    </div>
    <!-- ------------------------ **start ------------------------ -->
    <div class="car-introduce car-introduce2 lg:flex">
      <div
        class="flex-1 p-[30px] md:pl-[50px] md:pr-[50px] 2xl:pl-[150px] 2xl:pr-[150px]"
      >
        <div
          class="title font-semibold lg:text-4xl md:text-3xl text-2xl xl:pb-[30px] lg:pb-[20px] pb-[15px]"
        >
          Kia 首款商客兩用純電車型 PV5現正預售中
        </div>
        <div class="text xl:text-xl lg:text-lg text-base">
          Kia 首款專用車系
          PBV顛覆空間概念，為您度身訂造靈活多變的車廂佈局。無論商用，休閒或介於兩者之間，PV5都能滿足您不同需求。
        </div>
      </div>

      <div class="img-box flex-1">
        <img
          alt=""
          class="img aspect-3/3 object-cover"
          src="https://img.kamlung.net/kia/pv5/22.jpg"
        />
      </div>
    </div>
    <!-- ------------------------ **start ------------------------ -->
    <!-- 主轮播图 -->
    <div class="swiper2-box">
      <div class="swiper2-container">
        <swiper :options="swiperOption" ref="mySwiper" class="my-swiper">
          <swiper-slide v-for="item in 7" :key="item">
            <img
              :src="`https://img.kamlung.net/kia/pv5/swiper/${item}.jpg`"
              class="slide-image img md:aspect-6/4 aspect-5/4 object-cover"
            />
          </swiper-slide>
          <div class="swiper-button-prev custom-arrow" slot="button-prev"></div>
          <div class="swiper-button-next custom-arrow" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <!-- ------------------------ **start ------------------------ -->
    <div class="car-introduce lg:flex">
      <div class="img-box flex-1">
        <img
          alt=""
          class="img aspect-3/3 object-cover"
          src="https://img.kamlung.net/kia/pv5/44.jpg"
        />
      </div>

      <div
        class="text-box flex-1 p-[30px] md:pl-[50px] md:pr-[50px] 2xl:pl-[150px] 2xl:pr-[150px]"
      >
        <div class="text-box1">
          <div
            class="title font-semibold lg:text-4xl md:text-3xl text-2xl xl:pb-[30px] lg:pb-[20px] pb-[15px]"
          >
            Kia PV5 的設計理念是什麼？
          </div>
          <div class="text xl:text-xl lg:text-lg text-base">
            PV5 的現代設計靈感來自 Kia 屢獲殊榮的 「Opposites
            United」（對立統一）設計理念。它超越了傳統物流車輛的造型，提供了一種全新的美學,透過模組化強調靈活性和客製化,PV5將流線型的上部車身與堅固的技術性下部結構相結合。標誌性的技術照明與車輛的A
            柱無縫整合，呈現出簡潔的輪廓，展現了 Kia 的 PBV
            技術如何重新定義空間和移動性。黑色幾何輪拱護板和側裙板傳達出超強能力、無所不達的特性,而堅固的下保險桿角可互換，兼具美觀和保護功能。
            PV5的設計在車輛安全方面也發揮著關鍵作用，特別關注透過優化的引擎蓋點和腰線高度來改善前方和側面視野。
          </div>
          <p class="text-[10px] note pt-[30px] md:pt-[40px] xl:pt-[100px]">
            *實際車型車色及規格配備以實車為主
          </p>
        </div>
      </div>
    </div>
    <!------------------------- 主轮播图 -------------------------------------------------->
    <CarouselPage></CarouselPage>

    <!-- ------------------------ **start ------------------------ -->
    <div
      class="battery-info 2xl:aspect-5/3 xl:aspect-5/4 sm:aspect-5/5 aspect-5/7 bg-fixed"
    >
      <div
        class="text-box 2xl:top-[24%] lg:top-[30%] md:top-[36%] sm:top-[36%] top-[50%] md:p-[40px] p-[30px]"
      >
        <div class="title font-semibold md:text-4xl text-[24px] md:pb-[20px] pb-[15px]">
          電池配置及電動車平台
        </div>

        <p class="text-xs sm:text-sm md:text-base">• 配備 71.2 kWh 電池</p>
        <p class="text-xs sm:text-sm md:text-base">• 120 kW 前置馬達，產生 250 Nm 扭力</p>
        <p class="text-xs sm:text-sm md:text-base pb-[20px]">
          • 續航力最高 412 公里，快充時間為 30 分鐘 (10% - 80%)
        </p>

        <p class="text-xs sm:text-sm md:text-base pb-[15px]">
          所有版本的 Kia PV5 由 71.2 kWh NCM 電池供電。
          採用「電芯直接封裝」（cell-to-pack）電池系統，透過將電芯直接整合到電池組中來消除對模組的需求，從而提升能源效率。
        </p>

        <p class="text-xs sm:text-sm md:text-base">
          首創 Electric-Global Modular Platform for
          Service（E-GMP.S，電動全球模組化服務平台）是專為 PBV
          設計的平台。該平台建立在現代電動車平台 E-GMP 的既有優勢之上，同時專注於滿足 PBV
          商業客戶的實際需求。這項創新的核心是整合模組化架構（IMA），它標準化了電池和馬達等關鍵組件。這種方法簡化了車輛開發、降低了成本，並最終提升了市場競爭力。
        </p>
        <p class="text-[10px] md:pt-[30px] pt-[20px]">
          *電池配置只供參考，所有數據與選配以正式公布之到港型號為準。
        </p>
      </div>
    </div>
    <!-- ------------------------ **start ------------------------ -->
    <!-- :gutter="8" -->
    <!-- style="width: 10vh" -->
    <div class="img-list">
      <el-row>
        <el-col :sm="12" :md="8" :key="item" v-for="item in 9" class="pb-[8px]">
          <div class="mask"></div>
          <el-image
            fit="cover"
            :preview-src-list="imgSrcList"
            class="img aspect-5/5 object-cover"
            :src="`https://img.kamlung.net/kia/pv5/list/${item}.jpg`"
          />
        </el-col>
      </el-row>
    </div>
    <!-- ?iopcmd=thumbnail&type=4&width=640&quality=60 -->
    <!-- ------------------------ **start ------------------------ -->
    <form-page></form-page>
    <footer-page></footer-page>
  </div>
</template>

<script>
import { carouselList, textList, imgsrc } from "@/assets/js/static.js";
import FormPage from "@/components/FormPage.vue";
import FooterPage from "@/components/FooterPage.vue";
import CarouselPage from "@/components/CarouselPage.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "HomeView",
  components: {
    Swiper,
    SwiperSlide,
    CarouselPage,
    FormPage,
    FooterPage,
  },
  data() {
    return {
      imageUrl: require("@/assets/img/list/7.jpg"),
      imgSrcList: [
        "https://img.kamlung.net/kia/pv5/list/1.jpg",
        "https://img.kamlung.net/kia/pv5/list/2.jpg",
        "https://img.kamlung.net/kia/pv5/list/3.jpg",
        "https://img.kamlung.net/kia/pv5/list/4.jpg",
        "https://img.kamlung.net/kia/pv5/list/5.jpg",
        "https://img.kamlung.net/kia/pv5/list/6.jpg",
        "https://img.kamlung.net/kia/pv5/list/7.jpg",
        "https://img.kamlung.net/kia/pv5/list/8.jpg",
        "https://img.kamlung.net/kia/pv5/list/9.jpg",
      ],
      imgsrc,
      carouselList,
      textList,
      speak: "中文",

      // -----------------------------
      swiperOptionTop: {
        loopedSlides: 8,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 关键：thumbs配置，绑定缩略图Swiper实例
        thumbs: {
          swiper: null, // 将在mounted中动态绑定
          // 可选：设置缩略图的其他参数
          slideThumbActiveClass: "swiper-slide-thumb-active",
        },
        // 其他可选配置
        loop: false, // 如果缩略图联动，通常不开启loop
        autoHeight: false,
        observer: true, // 监听DOM变化
        observeParents: true,
        observeSlideChildren: true,
        // 同步切换
        on: {
          slideChange: function () {
            // console.log("主轮播图切换", this.activeIndex);
          },
        },
      },

      // 缩略图配置
      swiperOptionThumbs: {
        direction: "vertical",
        // spaceBetween: 8,
        // slidesPerView: "auto", // 自动适应
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        freeMode: true,
        freeModeSticky: true,
        observer: true, // 监听DOM变化
        observeParents: true,
        observeSlideChildren: true,
        slidesPerView: 4,

        // 关键：取消noSwiping，否则无法点击
        // noSwiping: false, // 移除或设为false

        // 设置缩略图容器高度，让用户知道可以滚动
        height: window.innerWidth < 600 ? 350 : 600, // 根据实际需要设置

        // 响应式配置
        // breakpoints: {
        //   1024: {
        //     spaceBetween: 8,
        //     height: 600,
        //   },
        //   768: {
        //     spaceBetween: 8,
        //     height: 500,
        //   },
        //   640: {
        //     spaceBetween: 8,
        //     height: 400,
        //   },
        // },

        // 缩略图切换回调
        on: {
          slideChange: function () {
            // console.log("缩略图切换", this.activeIndex);
          },
          // 点击缩略图时手动同步主轮播图
          click: function (swiper) {
            if (swiper.clickedSlide) {
              // const slideIndex = swiper.clickedSlide.dataset.swiperSlideIndex;
              // 这里可以通过Vue实例方法同步到主轮播图
            }
          },
        },
      },
      // swiperOptionThumbs2: {
      //   spaceBetween: 10,
      //   slidesPerView: "auto", // 或设置为固定数字如 4
      //   watchSlidesVisibility: true,

      //   watchSlidesProgress: true,
      //   slideToClickedSlide: true,
      //   // virtualTranslate: true, // 关键：防止容器移动[citation:3]
      // },
      // --------------------------------
      // 2. Swiper 核心配置
      swiperOption: {
        // 同时显示的幻灯片数量设为‘auto’，或一个如1.2的小数
        slidesPerView: "auto",
        centeredSlides: true,
        // 幻灯片之间的间距，使露出的部分更明显
        spaceBetween: 8,
        // 循环播放（按需开启）
        loop: false,
        // 启用左右箭头导航
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 其他可选功能
        // pagination: { el: '.swiper-pagination' }, // 分页器
        // observer: true, // 数据变化后更新Swiper[citation:10]
        // observeParents: true // 父元素变化后更新Swiper[citation:10]
      },
    };
  },
  computed: {
    // 获取Swiper实例，便于调用方法
    // swiper() {
    //   return this.$refs.mySwiper.$swiper;
    // },
  },
  mounted() {
    // this.handleResize();
    // 确保缩略图Swiper实例已创建，然后动态绑定给主Swiper
    this.$nextTick(() => {
      // if (this.$refs?.swiperThumbs) {
      // const thumbsSwiper = this.$refs.swiperThumbs.$swiper;
      // this.$refs.swiperTop.$swiper.thumbs.swiper = thumbsSwiper;
      // }
    });

    // console.log(document.body.clientWidth);
    // this.speak = window.sessionStorage.getItem("speak_") || "中文";
    // window.addEventListener("resize", this.handleResize);
    // document.title = `Kia_PV5:${window.innerWidth}`;
  },
  methods: {
    handleResize() {},
    handleCommand(e) {
      this.speak = e;
      window.sessionStorage.setItem("speak_", e);
      // console.log("click on item " + e);
    },
    downloadPDF() {
      const link = document.createElement("a");
      link.href = "https://ssy.kamlung.net/excel/Kia PV5 e_leaflet.pdf";
      link.download = "filename.pdf";
      link.target = "_blank";
      link.click();
      // document.body.removeChild(link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "element-ui/lib/theme-chalk/display.css";

.contaier {
  .swiper-box {
    background-color: #f00;
  }

  .top-nav {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 99;

    .top-logo {
    }

    .dropdown-box {
      position: absolute;
      top: 30px;
      right: 20px;
    }
  }

  .top-banner {
    position: relative;
    margin-top: 80px;

    .title-box {
      width: 100%;
      max-width: 1000px;
      padding: 0 20px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      text-align: left;
      color: #fff;

      .note {
        text-align: right;
      }

      .title1 {
        font-weight: bold;
        font-family: "KiaSignatureFixBold", sans-serif;
      }

      .title2 {
        font-family: "KiaSignatureFixBold", sans-serif;
      }

      .title3 {
        font-family: "KiaSignatureFixBold", sans-serif;
      }
    }

    .contact-box {
      width: 100%;
      max-width: 1000px;
      padding: 0 20px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      text-align: left;
      color: #fff;

      .title2 {
        font-family: "KiaSignatureFixBold", sans-serif;
      }
    }

    .img {
      object-fit: cover;
    }
    .download-btn {
      cursor: pointer;
    }
  }

  .car-introduce {
    background-color: #000;
    color: #fff;
    align-items: center;

    .text-box {
      // position:r
      // position:re
      height: 100%;
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      // justify-content: center;
      // align-items: center;
    }

    .text-box1 {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .title {
      font-family: "KiaSignatureFixBold", sans-serif;
    }

    .note {
      white: 100%;
      // margin-top: 30px;
      // margin-top: auto;
      text-align: right;
    }
  }

  // .car-introduce2 {
  //   align-items: start;
  // }
  .battery-info {
    position: relative;
    // background-image: url(@/assets/img/704438.jpg);
    background-image: url(https://img.kamlung.net/kia/pv5/704438.jpg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    // background-color: #000;
    .text-box {
      width: 90%;
      max-width: 880px;
      // padding: 40px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #000;
      border-radius: 15px;
      color: #fff;
    }
  }

  .img-list {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // width: calc(100vw - 24px);
    // max-width: 100%;
    // width: 100%;
    background-color: #000;

    .mask-box {
      position: relative;
    }

    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background-color: rgba(0, 0, 0, 0);
      z-index: 96;
      // pointer-events: none;
    }
    .mask {
      display: none;
      background-color: rgba(0, 0, 0, 0.4) !important ;
      pointer-events: none;
    }

    .el-row {
      // margin: 0 -10px;
    }

    .el-col {
      position: relative;
      padding: 0 4px 8px 4px;
      // margin: 0 4px;
    }
    .el-col:hover {
      // position: relative;
      // padding: 0 4px 8px 4px;
      // margin: 0 4px;
      .mask {
        display: inline-block;
        // background-color: rgba(0, 0, 0, 0.4) !important ;
        // pointer-events: none;
      }
    }
  }

  .carousel-row {
    padding: 50px 0;
    background-color: #000;

    .carousel-box {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      overflow: hidden;

      .carousel {
        flex: 1;

        .img-box {
          background-color: aqua;

          .img {
            height: auto;
          }
        }
      }
    }

    .scroll- {
      width: 200px;
      padding: 8px;
      overflow-x: auto;

      .scroll- {
        color: #fff;

        .img-box:nth-child(n + 2) {
          padding-top: 8px;
        }
      }
    }
  }
}

/* 主图样式 */
.gallery-top {
  flex: 1;
}

/* 缩略图样式 */
.gallery-thumbs {
  // max-height: 100%;
  // height: 100%;
  box-sizing: border-box;
  padding: 0 8px;

  .swiper-slide {
    overflow: hidden;
    opacity: 0.4;
  }

  .swiper-slide-thumb-active {
    opacity: 1;
    /* 激活的缩略图高亮 */
  }
}

.gallery-thumbs2 {
  width: 100%;

  .swiper-slide {
    width: 80px;
  }
}

.gallery-top .swiper-button-next,
.gallery-top .swiper-button-prev {
  /* 基础重置，避免继承其他样式 */
  background-image: none;
  /* 如果不想用Swiper默认的箭头图形，可以去掉这行注释 */
  width: 30px;
  height: 30px;
  margin-top: -15px;
  /* 配合 height 的一半，实现垂直居中 */
  color: #fff;
  /* 箭头颜色 */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* 如果使用Swiper默认箭头，并想更改颜色，可以这样设置 */
/* .gallery-top .swiper-button-next:after,
.gallery-top .swiper-button-prev:after {
    color: white;
} */

/* 分别设置左右箭头的位置 */
.gallery-top .swiper-button-next {
  right: 10px;
  /* 紧贴主图区域右侧 */
}

.gallery-top .swiper-button-prev {
  left: 10px;
  /* 紧贴主图区域左侧 */
}

/* --------------------------------*/
.swiper2-box {
  background-color: #000;

  .swiper2-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    position: relative;
  }

  .my-swiper {
    .swiper-slide {
      width: 80%;
      overflow: hidden;
    }
  }

  .custom-arrow {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    z-index: 999;
  }

  .custom-arrow::after {
    font-size: 20px;
  }
}
</style>
